export default {"src":"/_next/static/media/card1.3776573a.svg","height":236,"width":343,"blurWidth":0,"blurHeight":0};